import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .confirm-modal {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .confirm-modal-inputs {
    width: 100%;
    padding-bottom: 16px;
  }
  .confirm-modal-wrapper,
  .reason-selector-wrapper {
    margin-bottom: 8px;
  }
  .confirm-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .confirm-modal :global(.submit-button:hover) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .confirm-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .confirm-modal :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
